if (!customElements.get('adev-trustpilot-reviews')) {
    customElements.define('adev-trustpilot-reviews', class adevTrustpilotReviews extends HTMLElement {
        constructor() {
            super();
        }

        initSlider() {
            const carouselEl = this.querySelector('[data-adev-trustpilot-reviews="carousel"]');

            this.slider = new Flickity(carouselEl, {
                cellAlign: 'left',
                contain: true,
                pageDots: true,
                prevNextButtons: false,
                groupCells: false, // shows one card at a time but keeps others visible
                wrapAround: true,  // infinite loop
                draggable: true,
                freeScroll: false,
                adaptiveHeight: false,
                on: {
                    ready: function() {
                        this.slider.classList.add("flickity-resize");
                    }
                }
            });

            const prevArrow = this.querySelector('[data-adev-trustpilot-reviews="prev"]');
            const nextArrow = this.querySelector('[data-adev-trustpilot-reviews="next"]');

            if (prevArrow) {
                prevArrow.addEventListener('click', () => {
                    this.slider.previous();
                });
            }

            if (nextArrow) {
                nextArrow.addEventListener('click', () => {
                    this.slider.next();
                });
            }
        }

        destroySlider(){
            if (this.slider) {
                this.slider.destroy();
            }
        }

        shopifyCustomizerInit(){
            if (Shopify.designMode) {
                document.addEventListener('shopify:block:select', (e) => {
                    const block = e.detail;

                    const blockId = block.blockId;
                    const sectionId = block.sectionId;

                    const blockElement = this.querySelector(`[data-id="${blockId}"]`);
                    
                    if (blockElement) {
                        const index = blockElement.getAttribute('data-index');
                        this.slider.select(index);
                    }
                });
            }
        }
        
        connectedCallback() {
            this.initSlider();
            this.shopifyCustomizerInit();
        }

        disconnectedCallback() {
            this.destroySlider();
        }

    });
}